module.exports = __webpack_public_path__ + "static/img/03.57bd5b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/03.png
// module id = Gu3W
// module chunks = 0